import { UploadArea } from 'components/UploadArea'
import UploadedImageView from './SingleUploadedImageView'
import AiCharactersIcon from 'assets/svgr-icons/AI_Characters.svg'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { openMediaLib } from 'utils/media'
import { MEDIA_LIB_FOLDERS } from 'consts/mediaLib'
import { memo, useCallback } from 'react'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import { useSelector } from 'react-redux'
import { isBlobUrl } from 'utils'
import { useFrameHandlers } from '../hooks/useFrameHandlers'
import { ReferenceMediaImageType } from 'types/aiVideo'
import { IMyFilesMediaItem } from 'types/media'

const SingleRefContainer: React.FC = () => {
  const firstFrame = useSelector(aiVideoSelectors.firstFrame)
  const { url, isLoading } = firstFrame || {}
  const isImageUploading = isLoading || isBlobUrl(url)

  const { addFrameFromMediaLib, onUploadFrame, handleRemoveFrame } =
    useFrameHandlers()

  const addFirstFrameFromMediaLib = useCallback(
    (files: IMyFilesMediaItem[]) => {
      addFrameFromMediaLib(ReferenceMediaImageType.FIRST_FRAME, files)
    },
    [addFrameFromMediaLib]
  )

  const uploadFirstFrame = useCallback(
    (files: File[] | FileList) => {
      return onUploadFrame(ReferenceMediaImageType.FIRST_FRAME)(files)
    },
    [onUploadFrame]
  )

  return firstFrame ? (
    <UploadedImageView
      frameData={firstFrame}
      onUploadMedias={uploadFirstFrame}
      onAddMediaItemsFromMyFiles={addFirstFrameFromMediaLib}
      onRemoveImage={handleRemoveFrame}
    />
  ) : (
    <UploadArea
      handleFilesUpload={uploadFirstFrame}
      acceptType="AIVideoImage"
      mediaLibConfig={{
        fileType: 'image',
        initialFolderName: MEDIA_LIB_FOLDERS.aiImages,
        maxFileImportCount: 1
      }}
      handleMediaLibFiles={addFirstFrameFromMediaLib}
      isLoading={isImageUploading}
      extraActions={[
        {
          key: 'ai_characters',
          title: translate(T.AI_CHARACTERS_LABEL),
          icon: <AiCharactersIcon />,
          onClick: () => {
            openMediaLib({
              onChoose: addFirstFrameFromMediaLib,
              initialFolderName: MEDIA_LIB_FOLDERS.aiCharacters
            })
          }
        }
      ]}
    />
  )
}

export default memo(SingleRefContainer)
